// import React, { useEffect, useState } from "react";
// import {
//   Form,
//   Input,
//   Button,
//   Select,
//   Upload,
//   Card,
//   Space,
//   message,
//   Divider,
//   Layout,
//   Image,
//   Spin,
// } from "antd";
// import {
//   UploadOutlined,
//   PlusOutlined,
//   DeleteOutlined,
//   MenuFoldOutlined,
//   MenuUnfoldOutlined,
// } from "@ant-design/icons";
// import { useParams, useNavigate } from "react-router-dom";
// import Sidebar from "../Components/Sidebar";
// import { BASE_URL } from "../Config";
// import axios from "axios";
// import SuccessPopup from "../Components/popup/SuccessPopup";
// import ErrorPopup from "../Components/popup/ErrorPopup";
// import countries from "world-countries";

// const { TextArea } = Input;
// const { Content, Header } = Layout;

// export default function EditAsana() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [form] = Form.useForm();

//   const [loading, setLoading] = useState(true);
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);

//   const [mainImage, setMainImage] = useState(null); // string or File
//   const [variationImages, setVariationImages] = useState([]); // only new uploaded Files

//   const [variationPoses, setVariationPoses] = useState([
//     { name: "", sanskrit: "", english: "", poseType: "", mediaLink: "" },
//   ]);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   useEffect(() => {
//     fetchAsana();
//   }, [id]);

//   const fetchAsana = async () => {
//     try {
//       const token = sessionStorage.getItem("token");
//       setLoading(true);
//       const res = await axios.get(`${BASE_URL}/asanadetails/${id}`);
//       const data = res.data.asana || res.data;

//       form.setFieldsValue({
//         name: data.name,
//         sanskrit: data.sanskrit,
//         tamil: data.tamil,
//         english: data.english,
//         poseType: Array.isArray(data.poseType)
//           ? data.poseType.join(", ")
//           : data.poseType,
//         level: data.level,
//         breath: data.breath,
//         chakra: data.chakra,
//         howToDo: data.howToDo?.join("\n"),
//         benefits: data.benefits?.join("\n"),
//         precautions: data.precautions?.join("\n"),
//       });

//       setMainImage(data.mainImage);

//       setVariationPoses(
//         data.variationPoses?.length
//           ? data.variationPoses.map((v) => ({
//             name: v.name,
//             sanskrit: v.sanskrit,
//             country: v.country,
//             english: v.english,
//             image: v.image,
//             poseType: Array.isArray(v.poseType) ? v.poseType.join(", ") : "",
//             mediaLink: v.mediaLink,
//           }))
//           : [
//             {
//               name: "",
//               sanskrit: "",
//               english: "",
//               poseType: "",
//               image: "",
//               mediaLink: "",
//             },
//           ],
//       );

//       setVariationImages([]);
//     } catch (err) {
//       message.error("Failed to load asana");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const addVariationPose = () => {
//     setVariationPoses([
//       ...variationPoses,
//       { name: "", sanskrit: "", english: "", poseType: "", mediaLink: "" },
//     ]);
//   };

//   const countryOptions = countries
//     .map((c) => ({
//       label: c.name.common,
//       value: c.name.common,
//     }))
//     .sort((a, b) => a.label.localeCompare(b.label));

//   const removeVariationPose = (index) => {
//     const vp = [...variationPoses];
//     vp.splice(index, 1);
//     setVariationPoses(vp);

//     const imgs = [...variationImages];
//     imgs.splice(index, 1);
//     setVariationImages(imgs);
//   };

//   const updateVariationField = (index, field, value) => {
//     const vp = [...variationPoses];
//     vp[index][field] = value;
//     setVariationPoses(vp);
//   };

//   const handleUpdate = async (values) => {
//     const fd = new FormData();

//     const poseTypeArray = values.poseType
//       .split(",")
//       .map((v) => v.trim())
//       .filter(Boolean);

//     const howToDoArr = values.howToDo
//       .split("\n")
//       .map((v) => v.trim())
//       .filter(Boolean);

//     const benefitsArr = values.benefits
//       .split("\n")
//       .map((v) => v.trim())
//       .filter(Boolean);

//     const precautionsArr = values.precautions
//       .split("\n")
//       .map((v) => v.trim())
//       .filter(Boolean);

//     fd.append("name", values.name);
//     fd.append("sanskrit", values.sanskrit);
//     fd.append("tamil", values.tamil);
//     fd.append("english", values.english);
//     fd.append("breath", values.breath);
//     fd.append("chakra", values.chakra);
//     fd.append("level", values.level);

//     poseTypeArray.forEach((item) => {
//       fd.append("poseType[]", item);
//     });

//     fd.append("howToDo", JSON.stringify(howToDoArr));
//     fd.append("benefits", JSON.stringify(benefitsArr));
//     fd.append("precautions", JSON.stringify(precautionsArr));

//     const vpClean = variationPoses.map((vp, i) => {
//       if (variationImages[i]) {
//         return {
//           ...vp,
//           image:
//             vp.image &&
//               typeof vp.image === "string" &&
//               vp.image.startsWith("blob")
//               ? "" // remove blob URL
//               : vp.image,
//         };
//       }
//       return vp;
//     });

//     fd.append("variationPoses", JSON.stringify(vpClean));

//     if (mainImage && typeof mainImage !== "string") {
//       fd.append("mainImage", mainImage);
//     }

//     variationImages.forEach((file) => {
//       if (file) fd.append("images", file);
//     });

//     const token = sessionStorage.getItem("token");

//     try {
//       await axios.put(`${BASE_URL}/asanadetails/${id}`, fd, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setSuccessPopup(true); // show success popup
//     } catch (err) {
//       console.log(err);
//       setErrorPopup(true);
//     }
//   };

//   if (loading) {
//     return (
//       <div style={{ textAlign: "center", marginTop: 100 }}>
//         <Spin size="large" />
//       </div>
//     );
//   }

//   return (
//     <Layout style={{ minHeight: "100vh" }}>
//       <Sidebar collapsed={collapsed} role="admin" />

//       <Layout
//         style={{
//           marginLeft: isMobile ? (collapsed ? 0 : 200) : 0,
//           transition: "0.3s",
//         }}
//       >
//         <Header
//           className="MainHeader"
//         >
//           <Button
//             type="text"
//             icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
//             onClick={() => setCollapsed(!collapsed)}
//             style={{ fontSize: 18, width: 60 }}
//           />
//           <h2 style={{ margin: 0 }}>Edit Asana</h2>
//         </Header>

//         <Content style={{ padding: 20 }}>
//           <Card style={{ maxWidth: 900, margin: "0 auto" }}>
//             <Form form={form} layout="vertical" onFinish={handleUpdate}>
//               <Card title="Basic Information" style={{ marginBottom: 20 }}>
//                 <Form.Item
//                   name="name"
//                   label="Asana Name"
//                   rules={[{ required: true }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item
//                   name="sanskrit"
//                   label="Sanskrit"
//                   rules={[{ required: true }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item
//                   name="tamil"
//                   label="Tamil"
//                   rules={[{ required: true }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item
//                   name="english"
//                   label="English"
//                   rules={[{ required: true }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item
//                   name="poseType"
//                   label="Pose Type"
//                   rules={[{ required: true }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item name="level" label="Level">
//                   <Select>
//                     <Select.Option value="all levels">All Levels</Select.Option>
//                     <Select.Option value="beginner">Beginner</Select.Option>
//                     <Select.Option value="intermediate">
//                       Intermediate
//                     </Select.Option>
//                     <Select.Option value="advanced">Advanced</Select.Option>
//                   </Select>
//                 </Form.Item>

//                 <Form.Item
//                   name="breath"
//                   label="Breath"
//                   rules={[{ required: true }]}
//                 >
//                   <Input />
//                 </Form.Item>

//                 <Form.Item
//                   name="chakra"
//                   label="Chakra"
//                   rules={[{ required: true }]}
//                 >
//                   <Input />
//                 </Form.Item>
//               </Card>

//               <Card title="Instructions" style={{ marginBottom: 20 }}>
//                 <Form.Item
//                   name="howToDo"
//                   label="How To Do"
//                   rules={[{ required: true }]}
//                 >
//                   <TextArea rows={4} />
//                 </Form.Item>

//                 <Form.Item
//                   name="benefits"
//                   label="Benefits"
//                   rules={[{ required: true }]}
//                 >
//                   <TextArea rows={3} />
//                 </Form.Item>

//                 <Form.Item
//                   name="precautions"
//                   label="Precautions"
//                   rules={[{ required: true }]}
//                 >
//                   <TextArea rows={3} />
//                 </Form.Item>
//               </Card>

//               <Card title="Main Image" style={{ marginBottom: 20 }}>
//                 <p>Current Main Image:</p>
//                 {mainImage ? (
//                   <Image
//                     width={240}
//                     src={
//                       typeof mainImage === "string"
//                         ? mainImage
//                         : URL.createObjectURL(mainImage)
//                     }
//                   />
//                 ) : (
//                   <p>No image</p>
//                 )}

//                 <p style={{ marginTop: 10 }}>Replace Main Image:</p>
//                 <Upload
//                   beforeUpload={(file) => {
//                     setMainImage(file);
//                     return false;
//                   }}
//                   maxCount={1}
//                 >
//                   <Button icon={<UploadOutlined />}>Upload New Image</Button>
//                 </Upload>
//               </Card>

//               <Card
//                 title="Variation Poses"
//                 extra={
//                   <Button icon={<PlusOutlined />} onClick={addVariationPose}>
//                     Add Variation
//                   </Button>
//                 }
//               >
//                 {variationPoses.map((v, i) => (
//                   <Card
//                     key={i}
//                     type="inner"
//                     title={`Variation ${i + 1}`}
//                     style={{ marginBottom: 12 }}
//                     extra={
//                       <Button
//                         danger
//                         icon={<DeleteOutlined />}
//                         onClick={() => removeVariationPose(i)}
//                       />
//                     }
//                   >
//                     <Space direction="vertical" style={{ width: "100%" }}>
//                       <Input
//                         placeholder="name"
//                         value={v.name}
//                         onChange={(e) =>
//                           updateVariationField(i, "Name", e.target.value)
//                         }
//                       />

//                       <Input
//                         placeholder="Sanskrit"
//                         value={v.sanskrit}
//                         onChange={(e) =>
//                           updateVariationField(i, "sanskrit", e.target.value)
//                         }
//                       />

//                       <Select
//                         showSearch
//                         placeholder="Select country"
//                         value={v?.country}
//                         options={countryOptions}
//                         optionFilterProp="label"
//                         onChange={(value) =>
//                           updateVariationField(i, "country", value)
//                         }
//                       />

//                       {/* <Input
//                         placeholder="Enter the country name"
//                         value={v.country}
//                         onChange={(e) =>
//                           updateVariationField(i, "country", e.target.value)
//                         }
//                       /> */}

//                       <Input
//                         placeholder="English"
//                         value={v.english}
//                         onChange={(e) =>
//                           updateVariationField(i, "english", e.target.value)
//                         }
//                       />

//                       <Input
//                         placeholder="pose Type"
//                         value={v?.poseType}
//                         onChange={(e) =>
//                           updateVariationField(i, "poseType", e.target.value)
//                         }
//                       />

//                       <Input
//                         placeholder="Media link"
//                         value={v.mediaLink}
//                         onChange={(e) =>
//                           updateVariationField(i, "mediaLink", e.target.value)
//                         }
//                       />

//                       <div>
//                         <p>Current Image:</p>
//                         {v.image ? (
//                           <Image width={160} src={v.image} />
//                         ) : (
//                           <p>No image</p>
//                         )}
//                       </div>

//                       {/* Replace Variation Image */}
//                       <Upload
//                         beforeUpload={(file) => {
//                           const imgs = [...variationImages];
//                           imgs[i] = file;
//                           setVariationImages(imgs);

//                           // update preview
//                           const vp = [...variationPoses];
//                           vp[i].image = URL.createObjectURL(file);
//                           setVariationPoses(vp);

//                           return false;
//                         }}
//                         maxCount={1}
//                       >
//                         <Button icon={<UploadOutlined />}>
//                           Upload New Variation Image
//                         </Button>
//                       </Upload>
//                     </Space>
//                   </Card>
//                 ))}
//               </Card>

//               <Divider />

//               <Space>
//                 <Button type="primary" htmlType="submit" size="large">
//                   Update Asana
//                 </Button>

//                 <Button size="large" onClick={fetchAsana}>
//                   Reset
//                 </Button>

//                 <Button size="large" onClick={() => navigate("/all-asana")}>
//                   Cancel
//                 </Button>
//               </Space>
//             </Form>
//           </Card>
//         </Content>
//         <SuccessPopup
//           open={successPopup}
//           message="Asana updated successfully!"
//           onClose={() => {
//             setSuccessPopup(false);
//             navigate("/all-asana");
//           }}
//         />

//         <ErrorPopup
//           open={errorPopup}
//           message="Failed to update Asana!"
//           onClose={() => setErrorPopup(false)}
//         />
//       </Layout>
//     </Layout>
//   );
// }

// import React, { useEffect, useState } from "react";
// import {
//   Form,
//   Input,
//   Button,
//   Select,
//   Upload,
//   Card,
//   Space,
//   message,
//   Divider,
//   Layout,
//   Image,
//   Spin,
// } from "antd";
// import {
//   UploadOutlined,
//   PlusOutlined,
//   DeleteOutlined,
//   MenuFoldOutlined,
//   MenuUnfoldOutlined,
// } from "@ant-design/icons";
// import { useParams, useNavigate } from "react-router-dom";
// import Sidebar from "../Components/Sidebar";
// import { BASE_URL } from "../Config";
// import axios from "axios";
// import SuccessPopup from "../Components/popup/SuccessPopup";
// import ErrorPopup from "../Components/popup/ErrorPopup";
// import TextEditor from "../Components/RichTextEditor/TextEditor"; // ✅ Import CKEditor wrapper
// import countries from "world-countries";

// const { Content, Header } = Layout;

// // ✅ Safely extract HTML string from field that could be:
// //    - array with HTML string: ["<ul>...</ul>"]
// //    - plain array: ["step1", "step2"]
// //    - plain string: "<ul>...</ul>"
// //    - JSON-stringified string: '"<ul>...</ul>"'
// const extractHtml = (field) => {
//   if (!field) return "";

//   // Array format
//   if (Array.isArray(field)) {
//     // New CKEditor format: single item containing HTML
//     if (field.length === 1 && typeof field[0] === "string" && field[0].trim().startsWith("<")) {
//       let html = field[0];
//       try {
//         const parsed = JSON.parse(html);
//         if (typeof parsed === "string") html = parsed;
//       } catch { /* use as-is */ }
//       return html;
//     }
//     // Old plain text array → convert to simple HTML list
//     return `<ul>${field.map((item) => `<li>${item}</li>`).join("")}</ul>`;
//   }

//   // JSON-stringified string
//   if (typeof field === "string") {
//     try {
//       const parsed = JSON.parse(field);
//       if (typeof parsed === "string") return parsed;
//     } catch { /* use as-is */ }
//     return field;
//   }

//   return "";
// };

// export default function EditAsana() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [form] = Form.useForm();

//   const [loading, setLoading] = useState(true);
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [successPopup, setSuccessPopup] = useState(false);
//   const [errorPopup, setErrorPopup] = useState(false);

//   // ✅ CKEditor field states
//   const [howToDo, setHowToDo] = useState("");
//   const [benefits, setBenefits] = useState("");
//   const [precautions, setPrecautions] = useState("");

//   // ✅ Validation error states
//   const [howToDoError, setHowToDoError] = useState(false);
//   const [benefitsError, setBenefitsError] = useState(false);
//   const [precautionsError, setPrecautionsError] = useState(false);

//   // ✅ Key to force CKEditor re-mount when data loads
//   const [editorKey, setEditorKey] = useState(0);

//   const [mainImage, setMainImage] = useState(null);
//   const [variationImages, setVariationImages] = useState([]);
//   const [variationPoses, setVariationPoses] = useState([
//     { name: "", sanskrit: "", english: "", poseType: "", mediaLink: "" },
//   ]);

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   useEffect(() => {
//     fetchAsana();
//   }, [id]);

//   const fetchAsana = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${BASE_URL}/asanadetails/${id}`);
//       const data = res.data.asana || res.data;

//       form.setFieldsValue({
//         name: data.name,
//         sanskrit: data.sanskrit,
//         tamil: data.tamil,
//         english: data.english,
//         poseType: Array.isArray(data.poseType)
//           ? data.poseType.join(", ")
//           : data.poseType,
//         level: data.level,
//         breath: data.breath,
//         chakra: data.chakra,
//       });

//       // ✅ Load existing content into CKEditor states
//       setHowToDo(extractHtml(data.howToDo));
//       setBenefits(extractHtml(data.benefits));
//       setPrecautions(extractHtml(data.precautions));

//       // ✅ Force CKEditor to re-mount with new data
//       setEditorKey((prev) => prev + 1);

//       setMainImage(data.mainImage);
//       setVariationPoses(
//         data.variationPoses?.length
//           ? data.variationPoses.map((v) => ({
//               name: v.name,
//               sanskrit: v.sanskrit,
//               country: v.country,
//               english: v.english,
//               image: v.image,
//               poseType: Array.isArray(v.poseType) ? v.poseType.join(", ") : "",
//               mediaLink: v.mediaLink,
//             }))
//           : [{ name: "", sanskrit: "", english: "", poseType: "", image: "", mediaLink: "" }]
//       );
//       setVariationImages([]);
//     } catch (err) {
//       message.error("Failed to load asana");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Strip HTML to check if editor is empty
//   const isEditorEmpty = (html) => html.replace(/<[^>]*>/g, "").trim().length === 0;

//   const addVariationPose = () => {
//     setVariationPoses([
//       ...variationPoses,
//       { name: "", sanskrit: "", english: "", poseType: "", mediaLink: "" },
//     ]);
//   };

//   const countryOptions = countries
//     .map((c) => ({ label: c.name.common, value: c.name.common }))
//     .sort((a, b) => a.label.localeCompare(b.label));

//   const removeVariationPose = (index) => {
//     const vp = [...variationPoses];
//     vp.splice(index, 1);
//     setVariationPoses(vp);
//     const imgs = [...variationImages];
//     imgs.splice(index, 1);
//     setVariationImages(imgs);
//   };

//   const updateVariationField = (index, field, value) => {
//     const vp = [...variationPoses];
//     vp[index][field] = value;
//     setVariationPoses(vp);
//   };

//   const handleUpdate = async (values) => {
//     // ✅ Validate CKEditor fields manually
//     let hasError = false;
//     if (isEditorEmpty(howToDo)) { setHowToDoError(true); hasError = true; }
//     if (isEditorEmpty(benefits)) { setBenefitsError(true); hasError = true; }
//     if (isEditorEmpty(precautions)) { setPrecautionsError(true); hasError = true; }
//     if (hasError) return;

//     const fd = new FormData();

//     const poseTypeArray = values.poseType
//       .split(",")
//       .map((v) => v.trim())
//       .filter(Boolean);

//     fd.append("name", values.name);
//     fd.append("sanskrit", values.sanskrit);
//     fd.append("tamil", values.tamil);
//     fd.append("english", values.english);
//     fd.append("breath", values.breath);
//     fd.append("chakra", values.chakra);
//     fd.append("level", values.level);
//     poseTypeArray.forEach((item) => fd.append("poseType[]", item));

//     // ✅ Send CKEditor HTML content
//     fd.append("howToDo", JSON.stringify(howToDo));
//     fd.append("benefits", JSON.stringify(benefits));
//     fd.append("precautions", JSON.stringify(precautions));

//     const vpClean = variationPoses.map((vp, i) => ({
//       ...vp,
//       image:
//         variationImages[i]
//           ? (typeof vp.image === "string" && vp.image.startsWith("blob") ? "" : vp.image)
//           : vp.image,
//     }));
//     fd.append("variationPoses", JSON.stringify(vpClean));

//     if (mainImage && typeof mainImage !== "string") fd.append("mainImage", mainImage);
//     variationImages.forEach((file) => { if (file) fd.append("images", file); });

//     const token = sessionStorage.getItem("token");
//     try {
//       await axios.put(`${BASE_URL}/asanadetails/${id}`, fd, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       setSuccessPopup(true);
//     } catch (err) {
//       console.log(err);
//       setErrorPopup(true);
//     }
//   };

//   const errorStyle = { color: "#ff4d4f", fontSize: 12, marginTop: 4 };

//   if (loading) {
//     return (
//       <div style={{ textAlign: "center", marginTop: 100 }}>
//         <Spin size="large" />
//       </div>
//     );
//   }

//   return (
//     <Layout style={{ minHeight: "100vh" }}>
//       <Sidebar collapsed={collapsed} role="admin" />

//       <Layout
//         style={{
//           marginLeft: isMobile ? (collapsed ? 0 : 200) : 0,
//           transition: "0.3s",
//         }}
//       >
//         <Header className="MainHeader">
//           <Button
//             type="text"
//             icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
//             onClick={() => setCollapsed(!collapsed)}
//             style={{ fontSize: 18, width: 60 }}
//           />
//           <h2 style={{ margin: 0 }}>Edit Asana</h2>
//         </Header>

//         <Content style={{ padding: 20 }}>
//           <Card style={{ maxWidth: 900, margin: "0 auto" }}>
//             <Form form={form} layout="vertical" onFinish={handleUpdate}>

//               {/* ── BASIC INFORMATION ── */}
//               <Card title="Basic Information" style={{ marginBottom: 20 }}>
//                 <Form.Item name="name" label="Asana Name" rules={[{ required: true }]}>
//                   <Input />
//                 </Form.Item>
//                 <Form.Item name="sanskrit" label="Sanskrit" rules={[{ required: true }]}>
//                   <Input />
//                 </Form.Item>
//                 <Form.Item name="tamil" label="Tamil" rules={[{ required: true }]}>
//                   <Input />
//                 </Form.Item>
//                 <Form.Item name="english" label="English" rules={[{ required: true }]}>
//                   <Input />
//                 </Form.Item>
//                 <Form.Item name="poseType" label="Pose Type" rules={[{ required: true }]}>
//                   <Input />
//                 </Form.Item>
//                 <Form.Item name="level" label="Level">
//                   <Select>
//                     <Select.Option value="all levels">All Levels</Select.Option>
//                     <Select.Option value="beginner">Beginner</Select.Option>
//                     <Select.Option value="intermediate">Intermediate</Select.Option>
//                     <Select.Option value="advanced">Advanced</Select.Option>
//                   </Select>
//                 </Form.Item>
//                 <Form.Item name="breath" label="Breath" rules={[{ required: true }]}>
//                   <Input />
//                 </Form.Item>
//                 <Form.Item name="chakra" label="Chakra" rules={[{ required: true }]}>
//                   <Input />
//                 </Form.Item>
//               </Card>

//               {/* ── INSTRUCTIONS with CKEditor ── */}
//               <Card title="Instructions" style={{ marginBottom: 20 }}>

//                 {/* HOW TO DO */}
//                 <Form.Item label="How To Do" required>
//                   <TextEditor
//                     key={`howToDo-${editorKey}`}
//                     initialData={howToDo}
//                     onChange={(data) => {
//                       setHowToDo(data);
//                       if (!isEditorEmpty(data)) setHowToDoError(false);
//                     }}
//                     uploadUrl={`${BASE_URL}/api/upload`}
//                   />
//                   {howToDoError && <p style={errorStyle}>Please enter how to do steps</p>}
//                 </Form.Item>

//                 {/* BENEFITS */}
//                 <Form.Item label="Benefits" required style={{ marginTop: 16 }}>
//                   <TextEditor
//                     key={`benefits-${editorKey}`}
//                     initialData={benefits}
//                     onChange={(data) => {
//                       setBenefits(data);
//                       if (!isEditorEmpty(data)) setBenefitsError(false);
//                     }}
//                     uploadUrl={`${BASE_URL}/api/upload`}
//                   />
//                   {benefitsError && <p style={errorStyle}>Please enter benefits</p>}
//                 </Form.Item>

//                 {/* PRECAUTIONS */}
//                 <Form.Item label="Precautions" required style={{ marginTop: 16 }}>
//                   <TextEditor
//                     key={`precautions-${editorKey}`}
//                     initialData={precautions}
//                     onChange={(data) => {
//                       setPrecautions(data);
//                       if (!isEditorEmpty(data)) setPrecautionsError(false);
//                     }}
//                     uploadUrl={`${BASE_URL}/api/upload`}
//                   />
//                   {precautionsError && <p style={errorStyle}>Please enter precautions</p>}
//                 </Form.Item>
//               </Card>

//               {/* ── MAIN IMAGE ── */}
//               <Card title="Main Image" style={{ marginBottom: 20 }}>
//                 <p>Current Main Image:</p>
//                 {mainImage ? (
//                   <Image
//                     width={240}
//                     src={typeof mainImage === "string" ? mainImage : URL.createObjectURL(mainImage)}
//                   />
//                 ) : (
//                   <p>No image</p>
//                 )}
//                 <p style={{ marginTop: 10 }}>Replace Main Image:</p>
//                 <Upload
//                   beforeUpload={(file) => { setMainImage(file); return false; }}
//                   maxCount={1}
//                 >
//                   <Button icon={<UploadOutlined />}>Upload New Image</Button>
//                 </Upload>
//               </Card>

//               {/* ── VARIATION POSES ── */}
//               <Card
//                 title="Variation Poses"
//                 extra={
//                   <Button icon={<PlusOutlined />} onClick={addVariationPose}>
//                     Add Variation
//                   </Button>
//                 }
//               >
//                 {variationPoses.map((v, i) => (
//                   <Card
//                     key={i}
//                     type="inner"
//                     title={`Variation ${i + 1}`}
//                     style={{ marginBottom: 12 }}
//                     extra={
//                       <Button danger icon={<DeleteOutlined />} onClick={() => removeVariationPose(i)} />
//                     }
//                   >
//                     <Space direction="vertical" style={{ width: "100%" }}>
//                       <Input
//                         placeholder="Name"
//                         value={v.name}
//                         onChange={(e) => updateVariationField(i, "name", e.target.value)}
//                       />
//                       <Input
//                         placeholder="Sanskrit"
//                         value={v.sanskrit}
//                         onChange={(e) => updateVariationField(i, "sanskrit", e.target.value)}
//                       />
//                       <Select
//                         showSearch
//                         placeholder="Select country"
//                         value={v?.country}
//                         options={countryOptions}
//                         optionFilterProp="label"
//                         style={{ width: "100%" }}
//                         onChange={(value) => updateVariationField(i, "country", value)}
//                       />
//                       <Input
//                         placeholder="English"
//                         value={v.english}
//                         onChange={(e) => updateVariationField(i, "english", e.target.value)}
//                       />
//                       <Input
//                         placeholder="Pose Type"
//                         value={v?.poseType}
//                         onChange={(e) => updateVariationField(i, "poseType", e.target.value)}
//                       />
//                       <Input
//                         placeholder="Media Link"
//                         value={v.mediaLink}
//                         onChange={(e) => updateVariationField(i, "mediaLink", e.target.value)}
//                       />
//                       <div>
//                         <p>Current Image:</p>
//                         {v.image ? <Image width={160} src={v.image} /> : <p>No image</p>}
//                       </div>
//                       <Upload
//                         beforeUpload={(file) => {
//                           const imgs = [...variationImages];
//                           imgs[i] = file;
//                           setVariationImages(imgs);
//                           const vp = [...variationPoses];
//                           vp[i].image = URL.createObjectURL(file);
//                           setVariationPoses(vp);
//                           return false;
//                         }}
//                         maxCount={1}
//                       >
//                         <Button icon={<UploadOutlined />}>Upload New Variation Image</Button>
//                       </Upload>
//                     </Space>
//                   </Card>
//                 ))}
//               </Card>

//               <Divider />

//               <Space>
//                 <Button type="primary" htmlType="submit" size="large">Update Asana</Button>
//                 <Button size="large" onClick={fetchAsana}>Reset</Button>
//                 <Button size="large" onClick={() => navigate("/all-asana")}>Cancel</Button>
//               </Space>
//             </Form>
//           </Card>
//         </Content>

//         <SuccessPopup
//           open={successPopup}
//           message="Asana updated successfully!"
//           onClose={() => { setSuccessPopup(false); navigate("/all-asana"); }}
//         />
//         <ErrorPopup
//           open={errorPopup}
//           message="Failed to update Asana!"
//           onClose={() => setErrorPopup(false)}
//         />
//       </Layout>
//     </Layout>
//   );
// }
import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Upload,
  Card,
  Space,
  message,
  Divider,
  Layout,
  Image,
  Spin,
} from "antd";
import {
  UploadOutlined,
  PlusOutlined,
  DeleteOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import { BASE_URL } from "../Config";
import axios from "axios";
import SuccessPopup from "../Components/popup/SuccessPopup";
import ErrorPopup from "../Components/popup/ErrorPopup";
import TextEditor from "../Components/RichTextEditor/TextEditor";
import countries from "world-countries";

const { Content, Header } = Layout;

// ✅ Safely extract HTML string from field that could be:
//    - array with HTML string: ["<ul>...</ul>"]
//    - plain array: ["step1", "step2"]
//    - plain string: "<ul>...</ul>"
//    - JSON-stringified string: '"<ul>...</ul>"'
const extractHtml = (field) => {
  if (!field) return "";

  if (Array.isArray(field)) {
    if (
      field.length === 1 &&
      typeof field[0] === "string" &&
      field[0].trim().startsWith("<")
    ) {
      let html = field[0];
      try {
        const parsed = JSON.parse(html);
        if (typeof parsed === "string") html = parsed;
      } catch {
        /* use as-is */
      }
      return html;
    }
    // Old plain text array → convert to HTML list
    return `<ul>${field.map((item) => `<li>${item}</li>`).join("")}</ul>`;
  }

  if (typeof field === "string") {
    try {
      const parsed = JSON.parse(field);
      if (typeof parsed === "string") return parsed;
    } catch {
      /* use as-is */
    }
    return field;
  }

  return "";
};

// ✅ Strip HTML tags to check if editor is empty
const isEditorEmpty = (html) =>
  !html || html.replace(/<[^>]*>/g, "").trim().length === 0;

export default function EditAsana() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [errorPopup, setErrorPopup] = useState(false);

  // ✅ CKEditor states
  const [howToDo, setHowToDo] = useState("");
  const [benefits, setBenefits] = useState("");
  const [precautions, setPrecautions] = useState("");

  // ✅ CKEditor validation errors
  const [howToDoError, setHowToDoError] = useState(false);
  const [benefitsError, setBenefitsError] = useState(false);
  const [precautionsError, setPrecautionsError] = useState(false);

  // ✅ Key to force CKEditor re-mount when data loads
  const [editorKey, setEditorKey] = useState(0);

  // Main image
  const [mainImage, setMainImage] = useState(null);

  // ✅ Two-array approach — clean separation of pose data and new files
  const [variationPoses, setVariationPoses] = useState([
    {
      name: "",
      sanskrit: "",
      english: "",
      country: "",
      poseType: "",
      mediaLink: "",
      image: "",
    },
  ]);
  const [variationImages, setVariationImages] = useState([]); // only new uploaded Files

  const countryOptions = countries
    .map((c) => ({ label: c.name.common, value: c.name.common }))
    .sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    fetchAsana();
  }, [id]);

  const fetchAsana = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");

      const res = await axios.get(`${BASE_URL}/asanadetails/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data.asana || res.data;

      form.setFieldsValue({
        name: data.name,
        sanskrit: data.sanskrit,
        tamil: data.tamil,
        english: data.english,
        poseType: Array.isArray(data.poseType)
          ? data.poseType.join(", ")
          : data.poseType,
        level: data.level,
        breath: data.breath,
        chakra: data.chakra,
      });

      // ✅ Load CKEditor content using extractHtml to handle all formats
      setHowToDo(extractHtml(data.howToDo));
      setBenefits(extractHtml(data.benefits));
      setPrecautions(extractHtml(data.precautions));

      // ✅ Force CKEditor to re-mount with fresh data
      setEditorKey((prev) => prev + 1);

      setMainImage(data.mainImage || null);

      const poses = data.variationPoses?.length
        ? data.variationPoses.map((v) => ({
            name: v.name || "",
            sanskrit: v.sanskrit || "",
            english: v.english || "",
            country: v.country || "",
            poseType: Array.isArray(v.poseType)
              ? v.poseType.join(", ")
              : v.poseType || "",
            mediaLink: v.mediaLink || "",
            image: v.image || "",
          }))
        : [
            {
              name: "",
              sanskrit: "",
              english: "",
              country: "",
              poseType: "",
              mediaLink: "",
              image: "",
            },
          ];

      setVariationPoses(poses);
      setVariationImages([]); // reset on fetch
    } catch (err) {
      message.error("Failed to load asana");
    } finally {
      setLoading(false);
    }
  };

  const addVariationPose = () => {
    setVariationPoses([
      ...variationPoses,
      {
        name: "",
        sanskrit: "",
        english: "",
        country: "",
        poseType: "",
        mediaLink: "",
        image: "",
      },
    ]);
  };

  const removeVariationPose = (index) => {
    const vp = [...variationPoses];
    vp.splice(index, 1);
    setVariationPoses(vp);

    const imgs = [...variationImages];
    imgs.splice(index, 1);
    setVariationImages(imgs);
  };

  // ✅ All lowercase field names — no typo
  const updateVariationField = (index, field, value) => {
    const vp = [...variationPoses];
    vp[index][field] = value;
    setVariationPoses(vp);
  };

  const handleUpdate = async (values) => {
    // ✅ Validate CKEditor fields manually
    
    let hasError = false;
    if (isEditorEmpty(howToDo)) { setHowToDoError(true); hasError = true; }
    if (isEditorEmpty(benefits)) { setBenefitsError(true); hasError = true; }
    if (isEditorEmpty(precautions)) { setPrecautionsError(true); hasError = true; }
    if (hasError) return;

    const fd = new FormData();

    const poseTypeArray = values.poseType
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    fd.append("name", values.name);
    fd.append("sanskrit", values.sanskrit);
    fd.append("tamil", values.tamil);
    fd.append("english", values.english);
    fd.append("breath", values.breath);
    fd.append("chakra", values.chakra);
    fd.append("level", values.level);
    poseTypeArray.forEach((item) => fd.append("poseType[]", item));

    // ✅ Send CKEditor HTML content as JSON strings
    fd.append("howToDo", JSON.stringify(howToDo));
    fd.append("benefits", JSON.stringify(benefits));
    fd.append("precautions", JSON.stringify(precautions));

    // ✅ Clean variation poses:
    //    - If new file uploaded → set image: "" (backend assigns Cloudinary URL)
    //    - Otherwise → keep existing Cloudinary URL
    const vpClean = variationPoses.map((vp, i) => ({
      name: vp.name || "",
      sanskrit: vp.sanskrit || "",
      english: vp.english || "",
      country: vp.country || "",
      poseType: vp.poseType || "",
      mediaLink: vp.mediaLink || "",
      image: variationImages[i] ? "" : vp.image || "",
    }));

    fd.append("variationPoses", JSON.stringify(vpClean));

    // ✅ Append main image only if new file selected
    if (mainImage && typeof mainImage !== "string") {
      fd.append("mainImage", mainImage);
    }

    // ✅ Append new variation image files
    variationImages.forEach((file, i) => {
  if (file) {
    fd.append("images", file);
    fd.append("imageIndexes", String(i));
  }
});
    console.log("variationImages length:", variationImages.length);
console.log("variationImages files:", variationImages.map((f, i) => `[${i}]: ${f?.name || 'empty'}`));
console.log("vpClean images:", vpClean.map((v, i) => `[${i}]: ${v.image || 'EMPTY'}`));

    const token = sessionStorage.getItem("token");

    try {
      await axios.put(`${BASE_URL}/asanadetails/${id}`, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      setSuccessPopup(true);
    } catch (err) {
      console.error(err);
      setErrorPopup(true);
    }
  };

  const errorStyle = { color: "#ff4d4f", fontSize: 12, marginTop: 4 };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar collapsed={collapsed} role="admin" />

      <Layout
        style={{
          marginLeft: isMobile ? (collapsed ? 0 : 200) : 0,
          transition: "0.3s",
        }}
      >
        <Header className="MainHeader">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: 18, width: 60 }}
          />
          <h2 style={{ margin: 0 }}>Edit Asana</h2>
        </Header>

        <Content style={{ padding: 20 }}>
          <Card style={{ maxWidth: 900, margin: "0 auto" }}>
            <Form form={form} layout="vertical" onFinish={handleUpdate}>

              {/* ── BASIC INFORMATION ── */}
              <Card title="Basic Information" style={{ marginBottom: 20 }}>
                <Form.Item name="name" label="Asana Name" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>

                <Form.Item name="sanskrit" label="Sanskrit" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>

                <Form.Item name="tamil" label="Tamil" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>

                <Form.Item name="english" label="English" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>

                <Form.Item name="poseType" label="Pose Type" rules={[{ required: true }]}>
                  <Input placeholder="Standing, Forward Bend" />
                </Form.Item>

                <Form.Item name="level" label="Level">
                  <Select>
                    <Select.Option value="all levels">All Levels</Select.Option>
                    <Select.Option value="beginner">Beginner</Select.Option>
                    <Select.Option value="intermediate">Intermediate</Select.Option>
                    <Select.Option value="advanced">Advanced</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item name="breath" label="Breath" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>

                <Form.Item name="chakra" label="Chakra" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>
              </Card>

              {/* ── INSTRUCTIONS with CKEditor ── */}
              <Card title="Instructions" style={{ marginBottom: 20 }}>

                <Form.Item label="How To Do" required>
                  <TextEditor
                    key={`howToDo-${editorKey}`}
                    initialData={howToDo}
                    onChange={(data) => {
                      setHowToDo(data);
                      if (!isEditorEmpty(data)) setHowToDoError(false);
                    }}
                    uploadUrl={`${BASE_URL}/upload`}
                  />
                  {howToDoError && <p style={errorStyle}>Please enter how to do steps</p>}
                </Form.Item>

                <Form.Item label="Benefits" required style={{ marginTop: 16 }}>
                  <TextEditor
                    key={`benefits-${editorKey}`}
                    initialData={benefits}
                    onChange={(data) => {
                      setBenefits(data);
                      if (!isEditorEmpty(data)) setBenefitsError(false);
                    }}
                    uploadUrl={`${BASE_URL}/upload`}
                  />
                  {benefitsError && <p style={errorStyle}>Please enter benefits</p>}
                </Form.Item>

                <Form.Item label="Precautions" required style={{ marginTop: 16 }}>
                  <TextEditor
                    key={`precautions-${editorKey}`}
                    initialData={precautions}
                    onChange={(data) => {
                      setPrecautions(data);
                      if (!isEditorEmpty(data)) setPrecautionsError(false);
                    }}
                    uploadUrl={`${BASE_URL}/upload`}
                  />
                  {precautionsError && <p style={errorStyle}>Please enter precautions</p>}
                </Form.Item>
              </Card>

              {/* ── MAIN IMAGE ── */}
              <Card title="Main Image" style={{ marginBottom: 20 }}>
                <p>Current Main Image:</p>
                {mainImage ? (
                  <Image
                    width={240}
                    src={
                      typeof mainImage === "string"
                        ? mainImage
                        : URL.createObjectURL(mainImage)
                    }
                  />
                ) : (
                  <p>No image</p>
                )}
                <p style={{ marginTop: 10 }}>Replace Main Image:</p>
                <Upload
                  showUploadList={false}
                  beforeUpload={(file) => {
                    setMainImage(file);
                    return false;
                  }}
                  maxCount={1}
                >
                  <Button icon={<UploadOutlined />}>Upload New Image</Button>
                </Upload>
              </Card>

              {/* ── VARIATION POSES ── */}
              <Card
                title="Variation Poses"
                style={{ marginBottom: 20 }}
                extra={
                  <Button icon={<PlusOutlined />} onClick={addVariationPose}>
                    Add Variation
                  </Button>
                }
              >
                {variationPoses.map((v, i) => (
                  <Card
                    key={i}
                    type="inner"
                    title={`Variation ${i + 1}`}
                    style={{ marginBottom: 12 }}
                    extra={
                      <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => removeVariationPose(i)}
                      />
                    }
                  >
                    <Space direction="vertical" style={{ width: "100%" }}>
                      <Input
                        placeholder="Name"
                        value={v.name}
                        onChange={(e) =>
                          updateVariationField(i, "name", e.target.value)
                        }
                      />

                      <Input
                        placeholder="Sanskrit"
                        value={v.sanskrit}
                        onChange={(e) =>
                          updateVariationField(i, "sanskrit", e.target.value)
                        }
                      />

                      <Select
                        showSearch
                        placeholder="Select Country"
                        value={v.country || undefined}
                        options={countryOptions}
                        optionFilterProp="label"
                        style={{ width: "100%" }}
                        onChange={(value) =>
                          updateVariationField(i, "country", value)
                        }
                      />

                      <Input
                        placeholder="English"
                        value={v.english}
                        onChange={(e) =>
                          updateVariationField(i, "english", e.target.value)
                        }
                      />

                      <Input
                        placeholder="Pose Type"
                        value={v.poseType}
                        onChange={(e) =>
                          updateVariationField(i, "poseType", e.target.value)
                        }
                      />

                      <Input
                        placeholder="Media Link"
                        value={v.mediaLink}
                        onChange={(e) =>
                          updateVariationField(i, "mediaLink", e.target.value)
                        }
                      />

                      {/* Image preview */}
                      <div>
                        <p>Current Image:</p>
                        {v.image ? (
                          <Image width={160} src={v.image} />
                        ) : (
                          <p>No image</p>
                        )}
                      </div>

                      {/* ✅ Upload — two-array approach, no pose object corruption */}
                      <Upload
                        showUploadList={false}
                        beforeUpload={(file) => {
                          // Store file separately in variationImages[i]
                          const imgs = [...variationImages];
                          imgs[i] = file;
                          setVariationImages(imgs);

                          // Update blob preview without corrupting pose object
                          const vp = [...variationPoses];
                          vp[i] = { ...vp[i], image: URL.createObjectURL(file) };
                          setVariationPoses(vp);

                          return false;
                        }}
                        maxCount={1}
                      >
                        <Button icon={<UploadOutlined />}>
                          Upload New Variation Image
                        </Button>
                      </Upload>
                    </Space>
                  </Card>
                ))}
              </Card>

              <Divider />

              <Space>
                <Button type="primary" htmlType="submit" size="large">
                  Update Asana
                </Button>

                <Button size="large" onClick={fetchAsana}>
                  Reset
                </Button>

                <Button size="large" onClick={() => navigate("/all-asana")}>
                  Cancel
                </Button>
              </Space>
            </Form>
          </Card>
        </Content>

        <SuccessPopup
          open={successPopup}
          message="Asana updated successfully!"
          onClose={() => {
            setSuccessPopup(false);
            navigate("/all-asana");
          }}
        />

        <ErrorPopup
          open={errorPopup}
          message="Failed to update Asana!"
          onClose={() => setErrorPopup(false)}
        />
      </Layout>
    </Layout>
  );
}